import { config } from './config';
import crypto from 'crypto';
export async function getAnswer(productLink, question, customerId, sessionId, website, productNumber, questionHistory) {
  try {
    
    const url = `${config.BASE_URL}/chat/answer`;

    const body = {
        url: productLink,
        ua: navigator.userAgent,
        site: website,
        c_id: customerId,
        q: question,
        se_id: sessionId,
        p_n: productNumber ? productNumber : null,
        qh: questionHistory
    }
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
    
    // Add more detailed error logging
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Response status:', response.status);
      console.error('Response status text:', response.statusText);
      console.error('Error response:', errorText);
      
      // Try to parse error response
      try {
        const errorJson = JSON.parse(errorText);
        throw new Error(errorJson.detail || `HTTP error! status: ${response.status}`);
      } catch (e) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }
    
    if (!response.body) {
      throw new Error('ReadableStream not supported');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    return {
      [Symbol.asyncIterator]: async function* () {
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          yield decoder.decode(value);
        }
      }
    };
  } catch (error) {
    console.error('Error fetching answer:', error);
    throw error;
  }
}